export function buildWebPageSchema({
  siteUrl,
  siteName,
  contentPage,
  pageUrl,
  type = 'WebPage',
  locale = 'fr',
}) {
  return {
    '@context': 'https://schema.org',
    '@type': type,
    name: contentPage.title,
    description: contentPage.description,
    url: pageUrl,
    inLanguage: locale === 'en' ? 'en-US' : 'fr-FR',
    isPartOf: {
      '@type': 'WebSite',
      name: siteName,
      url: siteUrl,
    },
    publisher: {
      '@type': 'Organization',
      name: siteName,
      url: siteUrl,
    },
  };
}
